import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Divider,
} from '@mui/material'
import { HighlightOff } from '@mui/icons-material'
import TimeStampedEntriesList from '../common/TimeStampedEntriesList'

/**
 * Read-only viewer for Timestamped Big Text entries.
 * Props:
 * - open: boolean
 * - onClose: () => void
 * - title?: string
 * - entries: Array<{ timestamp?: string, text?: string, user_id?: number | string }>
 * - resolveUserName?: (entry: any) => string  // Optional helper to map user_id to display name
 */
const TimeStampedBigTextViewer = ({ open, onClose, title = 'Timestamped Entries', entries = [], resolveUserName }) => {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      keepMounted
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      TransitionProps={{ timeout: 0 }}
      PaperProps={{
        sx: { maxHeight: '80vh' },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '14px',
          fontWeight: 600,
          color: '#27104e',
          pb: 1,
        }}
      >
        {title}
        <IconButton onClick={onClose} size="small">
          <HighlightOff />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 2 }}>
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 600,
            color: '#656D90',
            mb: 2,
          }}
        >
          All Entries {Array.isArray(entries) && entries.length > 0 ? `(${entries.length})` : ''}
        </Typography>

        {Array.isArray(entries) && entries.length > 0 ? (
          <TimeStampedEntriesList entries={entries} resolveUserName={resolveUserName} />
        ) : (
          <Box sx={{ textAlign: 'center', py: 4, color: '#999' }}>
            <Typography sx={{ fontSize: '12px', color: '#656A7E' }}>
              No entries yet.
            </Typography>
          </Box>
        )}

        <Divider sx={{ mt: 1 }} />
      </DialogContent>
    </Dialog>
  )
}

export default React.memo(TimeStampedBigTextViewer)


